import React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';

import LoyaltySetupScreen from '@/screens/setting/loyalty-setup/LoyaltySetupScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const LoyaltyPointNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  return (
    <Stack.Navigator
      initialRouteName="LoyaltySetupScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="LoyaltySetupScreen"
        component={LoyaltySetupScreen}
        options={(props) => {
          return {
            title: setTitleHeader('Loyalty Point Setup'),
            headerLeft: () => <HamburgerButton {...props} />,
            hideScroll: true,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default LoyaltyPointNavigator;
